// generated from 5_204_733 samples

import { z } from "zod";
import { common } from "../common";

export const filterGetBaseSchema = z.object({
  additional_filter_data: z.strictObject({}),
  allowed_for_predictions: z.literal(false),
  allowed_for_territories: z.literal(false),
  display_name: z.union([
    // null samples: 14 (0.00%)
    z.null(),
    // string samples: 5_041_758 (96.87%)
    z.string(),
    // object samples: 162_961 (3.13%)
    z.object({
      // undefined: 125_484 (77.00%), defined 37_477 (23.00%)
      data: z
        .array(
          z.union([
            // string samples: 117_940 (96.86%)
            z.string(),
            // object samples: 3_822 (3.14%)
            z.object({
              id: common.objectId,
              name: z.string(),
            }),
          ])
        )
        .optional(),
      // undefined: 162_930 (99.98%), defined 31 (0.02%)
      deleted_app: z.literal(true).optional(),
      // undefined: 162_958 (100.00%), defined 3 (0.00%)
      deleted_model: z.literal(true).optional(),
      // undefined: 159_653 (97.97%), defined 3_308 (2.03%)
      // true 511 (15.45%), false 2_797 (84.55%)
      expired: z.boolean().optional(),
      // format object-id: 126_481 (77.61%)
      id: z.string(),
      // undefined: 126_786 (77.80%), defined 36_175 (22.20%)
      // avg: 16.52, min: 1, max: 30
      num_days: z.int().min(1).max(30).optional(),
      // undefined: 126_786 (77.80%), defined 36_175 (22.20%)
      num_occurrences: z.int().min(0).optional(),
      // undefined: 136_856 (83.98%), defined 26_105 (16.02%)
      pre_filter_shell_value: z
        .object({
          // undefined: 173 (0.66%), defined 25_932 (99.34%)
          // true 4_769 (18.39%), false 21_163 (81.61%)
          expired: z.boolean().optional(),
          id: common.objectId,
          value: z.string(),
        })
        .optional(),
      // undefined: 126_786 (77.80%), defined 36_175 (22.20%)
      property_name: z.string().optional(),
      // undefined: 126_786 (77.80%), defined 36_175 (22.20%)
      // null: 77 (0.21%)
      property_value: z.string().nullable().optional(),
      value: z.string(),
    }),
  ]),
  filter_key: z.string(),
  only_for_workflow_step: z.literal(false),
  // true 3_527_177 (67.77%), false 1_677_556 (32.23%)
  varies_by_app_group: z.boolean(),
});
